import React, { useState, useEffect } from "react";

const Home = () => {
    const [commits, setCommits] = useState([]);
    const [commitStats, setCommitStats] = useState({});

    useEffect(() => {
        fetch(process.env.REACT_APP_BACKEND_URL + "get_all_ds_commits", {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({
                token: localStorage.getItem("token"),
                username: localStorage.getItem("user"),
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                setCommits(data);
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }, []);

    // Agrupar los commits por reviewer
    const commitsByReviewer = commits.reduce((acc, commit) => {
        if (!acc[commit.reviewer]) {
            acc[commit.reviewer] = [];
        }
        acc[commit.reviewer].push(commit);
        return acc;
    }, {});

    useEffect(() => {
        fetch(process.env.REACT_APP_BACKEND_URL + "get_all_ds_commits_stats", {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({
                token: localStorage.getItem("token"),
                username: localStorage.getItem("user"),
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                setCommitStats(data);
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }, []);

    return (
        <>
            <div>
                {/* Mostrar la barra de progreso para cada reviewer */}
                {Object.entries(commitsByReviewer).map(
                    ([reviewer, commitsFiltered]) => {
                        const secureCount = commitsFiltered.filter(
                            (c) => c.security !== null
                        ).length;
                        const total = commitsFiltered.length;
                        const percentage = (secureCount / total) * 100;

                        // Calcular color de la barra de progreso
                        const lightness = 80 - percentage * 0.5; // del 80% (claro) al 30% (oscuro)
                        const barColor = `hsl(120, 60%, ${lightness}%)`;

                        return (
                            <div className="m-10" key={reviewer}>
                                <h3>{reviewer}</h3>
                                {commitsFiltered.length > 0 && (
                                    <div className="flex items-center space-x-4">
                                        <div className="w-full bg-gray-200 rounded-full h-6 relative">
                                            <div
                                                className="h-6 rounded-full transition-all duration-500"
                                                style={{
                                                    width: `${percentage}%`,
                                                    backgroundColor: barColor,
                                                }}
                                            ></div>
                                        </div>
                                        <div className="text-sm font-semibold text-gray-700 whitespace-nowrap">
                                            {secureCount} / {total}
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    }
                )}
            </div>

            <div className="m-10">
                <div className="border-b border-gray-900/10 pb-12 justify-center">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">
                        Commits Stats
                    </h1>
                </div>

                <div className="mt-6 grid grid-cols-2">
                    {Object.entries(commitStats).map(([user]) => (
                        <div key={user} className="mb-4 col-span-1 text-left">
                            <h4 className="font-semibold ">{user}</h4>
                            {Object.entries(commitStats[user]).map(([key, value]) => {
                                const percent = value[1] !== 0 ? ((value[0] * 100) / value[1]).toFixed(2) : "0.00";
                                // Calculate green bar color based on percent (from light to dark green)
                                const lightness = 80 - percent * 0.5; // 80% (light) to 30% (dark)
                                // Set bar color: red if percent < 50, else green gradient
                                let barColor;
                                if (percent < 50) {
                                    barColor = "hsl(0, 70%, 60%)"; // red
                                } else {
                                    barColor = `hsl(120, 60%, ${80 - percent * 0.5}%)`; // green gradient
                                }
                                return (
                                    <div key={key}>
                                        <p>
                                            {key === '' ? 'No Keywords' : `${key}`}: {value[0]} / {value[1]}
                                        </p>
                                        <p className="text-right">
                                            {percent}%
                                        </p>
                                        <div className="w-full bg-gray-200 rounded-full h-4 mb-1">
                                            <div
                                                className="h-4 rounded-full transition-all duration-500"
                                                style={{
                                                    width: `${percent}%`,
                                                    backgroundColor: barColor,
                                                }}
                                            ></div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default Home;
